/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrClaimSocialFollowResponse
 */
export interface RttrClaimSocialFollowResponse {
    /**
     * 
     * @type {number}
     * @memberof RttrClaimSocialFollowResponse
     */
    pointsAwarded: number;
    /**
     * 
     * @type {string}
     * @memberof RttrClaimSocialFollowResponse
     */
    platform: string;
    /**
     * 
     * @type {number}
     * @memberof RttrClaimSocialFollowResponse
     */
    segmentIndex: number;
}

/**
 * Check if a given object implements the RttrClaimSocialFollowResponse interface.
 */
export function instanceOfRttrClaimSocialFollowResponse(value: object): value is RttrClaimSocialFollowResponse {
    if (!('pointsAwarded' in value) || value['pointsAwarded'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('segmentIndex' in value) || value['segmentIndex'] === undefined) return false;
    return true;
}

export function RttrClaimSocialFollowResponseFromJSON(json: any): RttrClaimSocialFollowResponse {
    return RttrClaimSocialFollowResponseFromJSONTyped(json, false);
}

export function RttrClaimSocialFollowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrClaimSocialFollowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsAwarded': json['pointsAwarded'],
        'platform': json['platform'],
        'segmentIndex': json['segmentIndex'],
    };
}

export function RttrClaimSocialFollowResponseToJSON(json: any): RttrClaimSocialFollowResponse {
    return RttrClaimSocialFollowResponseToJSONTyped(json, false);
}

export function RttrClaimSocialFollowResponseToJSONTyped(value?: RttrClaimSocialFollowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsAwarded': value['pointsAwarded'],
        'platform': value['platform'],
        'segmentIndex': value['segmentIndex'],
    };
}

